import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import React, { useCallback, useEffect, useRef } from 'react';
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import Tooltip from '@atlaskit/tooltip';
import { KEY_ENTER, KEY_SPACE } from '../constants';
import { css, jsx } from '@emotion/react';
import { N0, DN600A, B75 } from '@atlaskit/theme/colors';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
const ColorCard = props => {
  const {
    value,
    label,
    selected,
    focused,
    checkMarkColor = N0,
    isTabbing,
    onClick,
    onKeyDown
  } = props;
  const ref = useRef(null);
  const handleMouseDown = useCallback(event => {
    event.preventDefault();
  }, []);
  const handleClick = useCallback(event => {
    if (onClick) {
      event.preventDefault();
      onClick(value);
    }
  }, [onClick, value]);
  const handleKeyDown = useCallback(event => {
    const {
      key
    } = event;
    if ((isTabbing === undefined || isTabbing) && onKeyDown && (key === KEY_ENTER || key === KEY_SPACE)) {
      event.preventDefault();
      if (isTabbing) {
        event.stopPropagation();
      }
      onKeyDown(value);
    }
  }, [isTabbing, onKeyDown, value]);
  useEffect(() => {
    if (getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy')) {
      const refCurrent = ref.current;
      const handleKeyDown = e => {
        if (e.key === 'Tab') {
          e.stopPropagation();
          e.preventDefault();
        }
      };
      refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.addEventListener('keydown', handleKeyDown);
      return () => {
        refCurrent === null || refCurrent === void 0 ? void 0 : refCurrent.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, []);
  return jsx(Tooltip, {
    content: label
  }, jsx("div", _extends({
    css: [sharedColorContainerStyles, (isTabbing === undefined || isTabbing) && colorCardOptionTabbingStyles, focused && !isTabbing && colorCardOptionFocusedStyles],
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    onKeyDown: handleKeyDown,
    role: "radio",
    "aria-checked": selected
  }, !getBooleanFF('platform.jca11y-1559-dashboard-view-dashboard-remove-duplicate-aria-label_g5i3i') && {
    'aria-label': label
  }, {
    tabIndex: 0
  }, getBooleanFF('platform.color-picker-radio-button-functionality_6hkcy') && {
    ref: ref
  }), jsx("div", {
    css: colorCardWrapperStyles
  }, jsx("div", {
    css: colorCardContentStyles,
    style: {
      background: value || 'transparent'
    }
  }, selected && jsx("div", {
    css: colorCardContentCheckMarkStyles
  }, jsx(EditorDoneIcon, {
    primaryColor: checkMarkColor,
    label: ""
  }))))));
};
export default ColorCard;
const colorCardOptionTabbingStyles = css({
  ':hover, :focus': {
    borderColor: `var(--ds-border-focused, ${B75})`
  }
});
const colorCardOptionFocusedStyles = css({
  borderColor: `var(--ds-border-focused, ${B75})`
});
const colorCardContentCheckMarkStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  margin: '1px'
});
const sharedColorContainerStyles = css({
  display: 'inline-block',
  position: 'relative',
  width: "var(--ds-space-400, 32px)",
  height: "var(--ds-space-400, 32px)",
  border: '2px solid transparent',
  boxSizing: 'border-box',
  borderRadius: "var(--ds-border-radius-200, 6px)",
  transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  backgroundColor: `var(--ds-background-neutral-subtle, ${N0})`,
  borderColor: `var(--ds-background-neutral-subtle, ${N0})`,
  padding: "var(--ds-space-0, 0px)",
  cursor: 'pointer',
  outline: 'none'
});
const colorCardWrapperStyles = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
const colorCardContentStyles = css({
  width: "var(--ds-space-300, 24px)",
  height: "var(--ds-space-300, 24px)",
  borderRadius: "var(--ds-border-radius-100, 3px)",
  boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${DN600A})`}`
});